export default "__VITE_ASSET__7fcef0f7__"